const navigation =  (template) => ({
  mainContainer: null,
  mainContainerWidth: null,
  showMegaMenu: false,
  selectedHandle: null,
  selectedItem: null,
  showMobileMenu: false,
  selectedMobileHandle: null,
  showSubMenu: false,
  showThirdLevelSubMenu: false,
  body: null,
  selectedThirdLevelMobileHandle: null,
  menuInner: null,
  headerHeight: null,
  announcementBar: null,
  announcementBarHeight: '0px',
  headerGroup: null,
  headerGroupHeight: null,
  headerGroupFixed: null,
  scrollUp: "",
  scrollDown: "",
  lastScroll: 0,
  topPosition: 0,
  megaMenuOverlay: null,
  mobileMenuWrapper: null,
  mobileOverlay: null,
  mobileMenuBottomPanel: null,
  pageTemplate: null,
  backgroundIsTransparent: true,
  navigationItems: null,
  isPageHeaderTransparent: "false",
  stickyFilter: null,
  searchResultsContainer: null,
  headerFixed: null,
  init() {
    this.mainContainer = document.querySelector("main")
   // this.stickyFilter = document.querySelector(".sticky_filter")
    this.pageTemplate = this.mainContainer.getAttribute("data-template")
    this.isPageHeaderTransparent = this.$el.getAttribute("data-header-transparent") || "false"
    this.headerGroupFixed = document.querySelector(".header-group-fixed")
    this.scrollUp = "scroll-up"
    this.scrollDown = "scroll-down"
    this.announcementBar = document.querySelector(".announcement-bar")
    this.headerGroup = document.querySelector(".header-group")
    this.megaMenuOverlay = document.querySelector('.megamenu-overlay')
    this.mobileMenuWrapper = document.querySelectorAll('.mobile-menu__wrapper')
    this.mobileOverlay = document.querySelector('.mobile-overlay')
    this.mobileMenuBottomPanel = document.querySelector('.mobile-menu__bottom-panel')
    this.searchResultsContainer = document.querySelector('.search-suggestions')
    this.navigationItems = document.querySelectorAll(".navigation-item")
    this.headerFixed = document.querySelectorAll('.header-group-fixed')

    this.setTopPositionForstisky()

    if (window.pageYOffset > 0){
      this.backgroundIsTransparent = false
    }
    this.body = document.querySelector("html body")
    this.menuInner = document.querySelectorAll(".menu-inner")
    this.calculateHeaderWidth()
    window.addEventListener("resize", () => {
      this.setTopPositionForstisky()
      this.calculateHeaderWidth()
    })
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset

      if (this.pageTemplate === "index" || this.pageTemplate === "collection" || this.pageTemplate === "article" || this.isPageHeaderTransparent === "true"){
        this.backgroundIsTransparent = currentScroll <= 0;
      }

      if (currentScroll > 100 && currentScroll > this.lastScroll && !this.body.classList.contains(this.scrollDown)) {
        this.body.classList.remove(this.scrollUp)
        this.body.classList.add(this.scrollDown)
       
      }

     
      if (currentScroll < this.lastScroll && this.body.classList.contains(this.scrollDown)) {
        this.body.classList.remove(this.scrollDown)
        this.body.classList.add(this.scrollUp)
      }


      if (currentScroll < 50){
        this.body.classList.remove(this.scrollUp)
      }

      this.lastScroll = currentScroll
      this.calculateHeaderWidth()
    })
  },
  setTopPositionForstisky(){
    if (this.announcementBar){
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0
      this.announcementBarHeight = this.announcementBarHeight+'px';
    }
    if (this.headerGroup){
      this.headerGroupHeight = this.headerGroup ? this.headerGroup.offsetHeight : 0
      this.headerGroupHeight = this.headerGroupHeight +'px';
    }
    this.headerFixed.forEach(fixedElement => {
      fixedElement.classList.add('header-group-fixed-fixed')
		});
    document.documentElement.style.setProperty('--announsment-height', this.announcementBarHeight);
    document.documentElement.style.setProperty('--announsment-height-negativ', "-"+this.announcementBarHeight);
    document.documentElement.style.setProperty('--header-height', this.headerGroupHeight);
  },
  calculateHeaderWidth() {
    this.mainContainerWidth = this.mainContainer
    if (this.announcementBar){
      this.announcementBar.style.width = this.mainContainerWidth.offsetWidth + "px"
    }

    this.headerGroup.style.width = this.mainContainerWidth.offsetWidth + "px"
    this.megaMenuOverlay.style.width = this.mainContainerWidth.offsetWidth + "px"
    this.menuInner.forEach(element => {
      element.style.width = this.mainContainerWidth.offsetWidth + "px"
    })
  },
  preventBodyScroll() {
    document.querySelector("body").style.overflow = "scroll"
    document.querySelector("html").style.overflow = "hidden"
    document.querySelector("html").style.maxHeight = "100vh"
  },
  allowBodyScroll() {
    document.querySelector("body").style.overflow = ""
    document.querySelector("html").style.overflow = ""
    document.querySelector("html").style.maxHeight = ""
  },
  openMegaMenu(event, handle) {

    this.preventBodyScroll()
    if (window.innerWidth >= 991) {
      if (handle) {
        const navigationItems = document.querySelectorAll('.main-navigation__item')

        if (navigationItems){
          navigationItems.forEach(item=>{
            item.classList.remove('mega-menu-open')
          })
        }

        this.selectedItem = event.target
        const selectedItem = this.selectedItem.querySelector('.main-navigation__item')
        if (selectedItem){
          selectedItem.classList.add('mega-menu-open')
        }
        this.selectedHandle = event.target.querySelector(`[data-submenu]`).getAttribute("data-handle")
        this.showMegaMenu = true
      } else {
        this.showMegaMenu = false
        this.selectedHandle = null
        this.allowBodyScroll()
      }
      this.selectActiveNavigationItem(event)
    }
  },
  closeMegaMenu(event) {
    if (window.innerWidth >= 991) {
      const navigationItems = document.querySelectorAll('.main-navigation__item')

      if (navigationItems){
        navigationItems.forEach(item=>{
          item.classList.remove('mega-menu-open')
        })
      }
      this.showMegaMenu = false
      this.selectedHandle = null
      this.allowBodyScroll()
      this.selectActiveNavigationItem(event)
    }
  },
  openSimpleMenu(event, handle){
    this.preventBodyScroll()
    this.selectedHandle = event.target.querySelector(`[data-simple-menu]`).getAttribute("data-simple-menu-handle")
    this.showMegaMenu = true
    const navigationItems = document.querySelectorAll('.main-navigation__item')

    if (navigationItems){
      navigationItems.forEach(item=>{
        item.classList.remove('mega-menu-open')
      })
    }
    this.selectedItem = event.target
    const selectedItem = this.selectedItem.querySelector('.main-navigation__item')
    if (selectedItem){
      selectedItem.classList.add('mega-menu-open')
    }
    this.selectActiveNavigationItem(event)
  },
  openMobileMenu() {
    this.showMobileMenu = true
    document.querySelector("body").classList.add("overflow-hidden")
    if (this.body.style.overflow === "visible") {
      this.body.style.overflow = "hidden"
    }
    if (this.announcementBar){
      if (getComputedStyle(document.querySelector(".announcement-bar")).transform === "matrix(1, 0, 0, 1, 0, 0)") {
        document.querySelector(".mobile-menu__wrapper").style.height = "calc(" + window.visualViewport.height + "px - 2rem)"
      } 
      else {
        document.querySelector(".mobile-menu__wrapper").style.height = "100dvh"
      }
    }

  },
  closeMobileMenu() {
    this.showMobileMenu = false
    this.closeSubmenu()
    document.querySelector("body").classList.remove("overflow-hidden")
    this.body.style.overflow = "visible"
  },
  openSubmenu(event, handle) {
    this.showSubMenu = true
    this.selectedMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle")
  },
  openThirdSubmenu(event, handle) {
    this.showThirdLevelSubMenu = true
    this.selectedThirdLevelMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle")
  },
  closeSubmenu() {
    this.showSubMenu = false
  },
  closeThirdSubmenu() {
    this.showThirdLevelSubMenu = false
  },
  selectActiveNavigationItem(event){
    const selectedItemHeading = event.currentTarget.getAttribute("data-item-heading")
    this.navigationItems.forEach(item=>{
      item.style.opacity = "100%"
      item.classList.remove("inactive")
      const itemHeading = item.getAttribute("data-item-heading")

      if (itemHeading !== selectedItemHeading){
        item.classList.add("inactive")
        // item.style.opacity = "60%"
      }
    })
  },
  resetNavigationItemsStyles(){
    this.navigationItems.forEach(item=>{
      item.classList.remove("inactive")
      item.style.opacity = "100%"
    })
  }
})

export default navigation

document.addEventListener("alpine:init", () => {
  Alpine.data("navigation", navigation);
})